import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import { useState, useEffect } from 'react';

var useControlled = function useControlled(options) {
  var value = options.value,
      defaultValue = options.defaultValue;
  var isControlled = typeof value !== 'undefined';

  var _useState = useState(isControlled ? value : defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      innerValue = _useState2[0],
      setInnerValue = _useState2[1];

  useEffect(function () {
    if (isControlled) {
      setInnerValue(value);
    }
  }, [value, isControlled]);
  return [isControlled ? value : innerValue, setInnerValue];
};

export { useControlled };
//# sourceMappingURL=useControlled.js.map
